import { HTMLAttributes } from 'react';

import { cn } from './cn';

export const Skeleton = ({ className, ...props }: HTMLAttributes<HTMLDivElement>) => (
  <div
    aria-hidden="true"
    className={cn('animate-pulse rounded-auditor bg-line motion-reduce:animate-none', className)}
    {...props}
  />
);

export const Progress = ({
  className,
  label = 'Loading',
  value,
}: {
  className?: string;
  label?: string;
  value?: number;
}) => (
  <div
    role="progressbar"
    aria-label={label}
    aria-valuemin={0}
    aria-valuemax={100}
    aria-valuenow={value}
    className={cn('relative h-1 w-full overflow-hidden rounded-full bg-brand-subtle', className)}
  >
    {value === undefined ? (
      <div className="absolute inset-y-0 w-1/3 animate-progress rounded-full bg-brand motion-reduce:animate-none" />
    ) : (
      <div
        className="h-full rounded-full bg-brand transition-progress motion-reduce:transition-none"
        style={{ width: `${value}%` }}
      />
    )}
  </div>
);
